import { maxBreakpoints } from '@/utils/mediaQuery';
import styled from '@emotion/styled';

const SubmitButton = styled.button<{ mobileMode?: boolean }>`
  margin-top: 2px;
  display: flex;
  width: 80px;
  padding: 14px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
  background-color: #06c;
  color: white;
  font-size: ${({ mobileMode }) => (mobileMode ? '16px' : '14px')};
  font-weight: ${({ mobileMode }) => (mobileMode ? '400' : '500')};
  line-height: ${({ mobileMode }) => (mobileMode ? '24px' : '20px')};
  white-space: nowrap;
  min-width: 120px;

  @media screen and (${maxBreakpoints.xs}) {
    min-width: 65px;
  }
  :disabled {
    background-color: rgba(0, 102, 204, 0.2);
  }
`;

export { SubmitButton };
